import styled from 'styled-components'

export const Image = styled.img`
  width: 215px ;
  margin-top: 30px;
`
